import { get, post } from "@/utils/axiosInstance";
import { ENDPOINTS } from "../../constants";

const state = {
  market: [],
  perspective: [],
  platform: [],
  distribution: [],
  research: [],
  foreign: [],
  algoServer: [],
  selectedResearch: [],
  selectedForeign: [],
  selectedAlgoServer: [],
  algorithmDetail: [],
  researchDetail: [],
  featureSettings: [],
};

const actions = {
  getPlatform({ commit }, [applicationId, cusId = null]) {
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.getPlatform}/${applicationId}`, {}, cusId)
        .then((response) => {
          commit("setPlatform", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getMarket({ commit }, [applicationId, platformId, cusId = null]) {
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.getMarket}/${applicationId}/${platformId}`, {}, cusId)
        .then((response) => {
          commit("setMarket", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getPerspective(
    { commit },
    [applicationId, platformId, marketId, cusId = null]
  ) {
    return new Promise((resolve, reject) => {
      get(
        `${ENDPOINTS.getPerspective}/${applicationId}/${platformId}/${marketId}`,
        {},
        cusId
      )
        .then((response) => {
          commit("setPerspective", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDistribution(
    { commit },
    [applicationId, platformId, marketId, cusId = null]
  ) {
    return new Promise((resolve, reject) => {
      get(
        `${ENDPOINTS.getVendor}/${applicationId}/${platformId}/${marketId}`,
        {},
        cusId
      )
        .then((response) => {
          commit("setDistribution", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getResearch({ commit }, [applicationId, cusId = null]) {
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.getResearch}/${applicationId}`, {}, cusId)
        .then((response) => {
          commit("setResearch", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getForeign({ commit }, [applicationId, platformId, cusId = null]) {
    return new Promise((resolve, reject) => {
      get(
        `${ENDPOINTS.getForeignIndices}/${applicationId}/${platformId}`,
        {},
        cusId
      )
        .then((response) => {
          commit("setForeign", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAlgoServer({ commit }, [applicationId, cusId = null]) {
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.getAlgorithmAndServer}/${applicationId}`, {}, cusId)
        .then((response) => {
          commit("setAlgoServer", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAlgorithmDetail({ commit }, [algoId, cusId = null]) {
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.getAlgorithmDetail}/${algoId}`, {}, cusId)
        .then((response) => {
          commit("setAlgorithmDetail", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getResearchDetail({ commit }, [researchId]) {
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.getResearchDetail}/${researchId}`)
        .then((response) => {
          commit("setResearchDetail", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getFeatureSettings({ commit }, params) {
    return new Promise((resolve) => {
      post(ENDPOINTS.featureSettings, params).then((response) => {
        if (response.data) {
          commit("setFeatureSettings", response.data);
          resolve(response.data);
        } else {
          resolve(false);
        }
      });
    });
  },
};

const mutations = {
  setPlatform(state, platform) {
    state.platform = platform;
  },
  setMarket(state, market) {
    state.market = market;
  },
  setPerspective(state, perspective) {
    state.perspective = perspective;
  },
  setDistribution(state, distribution) {
    state.distribution = distribution;
  },
  setResearch(state, research) {
    state.research = research;
  },
  setForeign(state, foreign) {
    state.foreign = foreign;
  },
  setAlgoServer(state, algoServer) {
    state.algoServer = algoServer;
  },
  setSelectedResearch(state, selectedResearch) {
    state.selectedResearch = selectedResearch;
  },
  setSelectedForeign(state, selectedForeign) {
    state.selectedForeign = selectedForeign;
  },
  setSelectedAlgoServer(state, selectedAlgoServer) {
    state.selectedAlgoServer = selectedAlgoServer;
  },
  setAlgorithmDetail(state, algorithmDetail) {
    state.algorithmDetail = algorithmDetail;
  },
  setResearchDetail(state, researchDetail) {
    state.researchDetail = researchDetail;
  },
  setFeatureSettings(state, data) {
    state.featureSettings = data;
  },
};

const getters = {
  getPlatformInfo() {
    return state.platform;
  },
  getMarketInfo() {
    return state.market;
  },
  getPerspectiveInfo() {
    return state.perspective;
  },
  getDistributionInfo() {
    return state.distribution;
  },
  getResearchInfo() {
    return state.research;
  },
  getForeignInfo() {
    return state.foreign;
  },
  getAlgoServerInfo() {
    return state.algoServer;
  },
  getSelectedResearchInfo() {
    return state.selectedResearch;
  },
  getSelectedForeignInfo() {
    return state.selectedForeign;
  },
  getSelectedAlgoServerInfo() {
    return state.selectedAlgoServer;
  },
  getAlgorithmDetailInfo() {
    return state.algorithmDetail;
  },
  getResearchDetailInfo() {
    return state.researchDetail;
  },
  featureSettings() {
    return state.featureSettings;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
